const minLength = 8

module.exports = function() {
  return value => {
    // Return true if the password is at least minLength and has at least one uppercase letter
    // \u0080-\u024F is a (rough) latin character range, to allow Å, Ä, Ö etc
    return value.length >= minLength && /[A-Z]|[\u0080-\u024F]/.test(value)
  }
}
